import { Box, Typography } from "@mui/material";
import DataGridCustom from "components/DataGridCustom";
import DataGridCustomToolbar from "components/DataGridCustomToolbar";
import React, { useState } from "react";
import { useGetAllExpensesQuery } from "state/api";

const { useSelector } = require("react-redux");

const ExpenseTable = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const { data, isLoading } = useGetAllExpensesQuery({
    page,
    pageSize,
    sort: "",
    search,
  }); // Fetching data from the API
  const userRole = useSelector((state) => state.auth.userInfo.role);
  const columns = [
    {
      field: "expenseAmount",
      headerName: "Amount",
      flex: 0.3,
      renderCell: (params) => {
        return (
          <Typography variant="body2">
            {/* Display amount in INR */}
            {new Intl.NumberFormat("en-IN", {
              style: "currency",
              currency: "INR",
            }).format(params.row.expenseAmount)}
          </Typography>
        );
      },
    },
    {
      field: "category",
      headerName: "Category",
      flex: 0.3,
    },
    {
      field: "paymentMode",
      headerName: "Payment Mode",
      flex: 0.3,
    },
    {
      field: "date",
      headerName: "Date",
      flex: 0.3,
      renderCell: (params) => {
        return (
          <Typography variant="body2">
            {/* Display date in Month date, year format */}
            {new Date(params.row.date).toLocaleDateString("en-IN", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </Typography>
        );
      },
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography variant="inherit" sx={{
            p:1,
          }}>
            {params.row.description}
          </Typography>
        );
      }
    },
  ];

  return (
    <Box mt="40px" width="100%" height="75vh">
      <DataGridCustom
        loading={isLoading || !data}
        getRowId={(row) => row._id}
        rows={(data && data.result) || []}
        columns={
          // align header to center
          columns.map((column) => ({
            ...column,
            headerAlign: "center",
            align: "center",
          }))
        }
        disableSelectionOnClick
        rowCount={(data && data.total) || 0}
        rowsPerPageOptions={[10, 20, 50]}
        pagination
        pageSize={pageSize}
        paginationMode="server"
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        components={{ Toolbar: DataGridCustomToolbar }}
        componentsProps={{
          toolbar: {
            searchInput,
            setSearchInput,
            setSearch,
            userRole,
          },
        }}
        getRowHeight={({ model }) => {
          // get description of the expense with the given id
          const description = model.description;

          // if description is long then increase the row height
          if (description.length > 100) return "auto";

          return null;
        }}
        // getRowHeight={() => 'auto'}
        rowHeight={100}
        getEstimatedRowHeight={() => 200}
        autoHeight
        sx={{
          width: "100%",
        }}
      />
    </Box>
  );
};

export default ExpenseTable;
